
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import IngredientDisplay from "@/models/Ingredient/IngredientDisplay";
import { NutritionCountry } from "@/models/NutritionLabels/NutritionCountry";
import { mapState } from "vuex";
import VIconWithTooltip from "@/components/vIconWithTooltip.vue";

@Component({
  components: {VIconWithTooltip},
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vIngredientsDisplayNames extends Vue {
  localizationState: any;

  @Prop() ingredientDisplays!: IngredientDisplay[];
  @Prop() country!: NutritionCountry;
  @Prop() changedDisplays!: {type: "ingredient" | "subrecipe", id: number}[];

  // everytime we update name, tell the parent
  @Watch("activeIngredientId")
  onChangeActiveIngredientId() {
    this.$emit("update");
  }

  activeIngredientId: string = "0";

  setActiveIngredient(id: string) {
    this.activeIngredientId = id;
  }

  get translations() {
    return this.localizationState.translations;
  }

  get sortedIngredientDisplays(): IngredientDisplay[] {
    return this.ingredientDisplays.sort(
      (firstDisplay, secondDisplay) => secondDisplay.weightInGrams - firstDisplay.weightInGrams
    );
  }

  /**
   * Emits an event to reset the name of an ingredient or a subrecipe based on the provided display object.
   *
   * @param {IngredientDisplay} display - The object containing ingredient or recipe identification details.
   * @return {void} Emits either 'resetIngredientName' or 'resetSubrecipeName' with the corresponding ID.
   */
  emitResetIngredientName(display: IngredientDisplay) {
    if (display.ingredientId) {
      this.$emit('resetIngredientName', display.ingredientId);
    }

    else {
      this.$emit('resetSubrecipeName', display.recipeId);
    }
  }

  isModifiedDisplayName(display: IngredientDisplay) {
    console.log(display);
    if (display.ingredientId) {
      console.log("Changed ingredient?:", this.changedDisplays.some(
        (changedDisplay) => changedDisplay.type === "ingredient" && changedDisplay.id === display.ingredientId
      ));

      return this.changedDisplays.some(
        (changedDisplay) => changedDisplay.type === "ingredient" && changedDisplay.id === display.ingredientId
      );
    }

    console.log("Changed subrecipe?:",this.changedDisplays.some(
      (changedDisplay) => changedDisplay.type === "subrecipe" && changedDisplay.id === display.recipeId
    ));

    return this.changedDisplays.some(
      (changedDisplay) => changedDisplay.type === "subrecipe" && changedDisplay.id === display.recipeId
    );
  }
}
